import type {AggregationSurveySubmissionListItem}
    from "crqlar-react-common/dist/models/aggregation/surveyAggregation.model";
import {SurveyService} from "crqlar-react-common/dist/services/survey/survey.service";
import {useQuery} from "react-query";
import SurveySubmissionDialog from "./SurveySubmissionDialog";

interface ListSubmissionDialogProps {
    submission: AggregationSurveySubmissionListItem
    onClose: () => void
    /** The next open reply on the list; marking this one reviewed moves straight on to it. */
    nextOpenSubmissionId?: string
    onOpenSubmission?: (id: string) => void
    /** Opens a question-linked response at that answer instead of the first question. */
    initialQuestionId?: string
}

/** The submission dialog for a row of a list across surveys, which first has to load that row's survey. */
export function SurveyListSubmissionDialog({
    submission,
    onClose,
    nextOpenSubmissionId,
    onOpenSubmission,
    initialQuestionId = submission.searchMatch?.questionId
}: ListSubmissionDialogProps) {
    const surveyQuery = useQuery(
        ['survey', submission.surveyId],
        () => SurveyService.getSurveyById(submission.surveyId!),
        {enabled: !!submission.surveyId, refetchOnWindowFocus: false}
    );

    return (
        <SurveySubmissionDialog
            open
            onClose={onClose}
            submission={submission}
            survey={surveyQuery.data}
            loading={surveyQuery.isLoading}
            initialQuestionId={initialQuestionId}
            onReviewed={() => nextOpenSubmissionId && onOpenSubmission
                ? onOpenSubmission(nextOpenSubmissionId)
                : onClose()}
            hasNextOpen={!!nextOpenSubmissionId && !!onOpenSubmission}
        />
    );
}
